import { css } from 'lit-element';

export const styles = css`
  :host {
    border-radius: 1.875rem;
    display: flex;
    height: 100%;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    padding: min(0.5rem, 5cqw);
    container-name: single-post;
    box-sizing: border-box;
  }

  .card,
  .card-noimage {
    padding: 0;
    height: 100%;
    border-radius: 11px;
    width: 100%;
    box-shadow: 2px 2px 6px 0px
      rgba(112, 71.99999999999999, 24.999999999999996, 0.1);
  }

  .card-content {
    padding: 20px 20px 40px 20px;
  }
  .card-image_container {
    width: 100%;
  }

  .card-img_container img {
    display: block;
    margin: 0 auto;
    width: 100%;
    height: 150px;
    object-fit: cover;
    border-radius: 11px 11px 0 0;
  }

  .card-background {
    border-radius: 11px 11px 0 0;
    margin: 0 auto;
    display: block;
    height: 150px;
    width: 100%;
    background-color: pink;
  }

  .btn {
    text-decoration: none;
    display: inline-block;
    fill: #ffffff;
    color: #ffffff;
    background-color: #eb008c;
    border-radius: 11px 11px 11px 11px;
    box-shadow: 8px 7px 10px 0px
      rgba(112, 71.99999999999999, 24.999999999999996, 0.09);
    padding: 8px 22px 8px 22px;
    transition: 150ms ease-in-out;
  }
  .btn:hover {
    color: #ffffff;
    background-color: #b00068;
  }

  .loading {
    background-color: #ec008c;
    border-radius: 1.875rem;
    height: 100%;
    width: 100%;
    display: block;
    position: relative;
  }

  h2 {
    margin: 0;
    color: #ec008c;
    leading-trim: both;
    text-edge: cap;
    font-size: clamp(1.6em, 10vw, 1.75em);
    font-style: normal;
    font-weight: 300;
    line-height: 120%; /* 2.1rem */
    letter-spacing: -0.0175rem;
    font-family: 'Roboto', sans-serif;
  }

  .description {
    margin: 0;
    color: #7a7a7a;
    font-size: 16px;
    padding: 15px 0 30px 0;
  }

  @media screen and (min-width: 768px) {
  }

  @container single-post (width<200px) {
  }
`;
